'use client';
import * as React from 'react';
export const TagGroupContext = /*#__PURE__*/ React.createContext(undefined);
const tagGroupContextDefaultValue = {
    handleTagDismiss: ()=>({}),
    size: 'medium',
    role: 'toolbar',
    handleTagSelect: undefined
};
export const TagGroupContextProvider = TagGroupContext.Provider;
export const useTagGroupContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = React.useContext(TagGroupContext)) !== null && _React_useContext !== void 0 ? _React_useContext : tagGroupContextDefaultValue;
};
